export default __webpack_public_path__ + "static/media/Laugh.b098d073.mp3";